// This has emptied out results i.e. is static
const STATIC_BALLOT_PAGE =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2026_runoff/ballot_guide/results_FLAT_for_ballot.json';

// What we are using across the ap
// will be used on the results page, in the homepage takeover
// and in the embeds
const RESULTS_IN_USE = STATIC_BALLOT_PAGE;

export { RESULTS_IN_USE };
